import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
// import MenuPage from "./pages/MenuPage";
import MenuPageV2 from "./pages/MenuPageV2";
import CartPage from "./pages/CartPage";
import OrdersPage from "./pages/OrdersPage";
import OrderDetailPage from "./pages/OrderDetailPage";
import OrderHistoryPage from "./pages/OrderHistoryPage";
import RestaurantDashboard from "./pages/RestaurantDashboard";
import AnalyticsPage from "./pages/AnalyticsPage";
import SuccessPage from "./pages/SuccessPage";
import OrderConfirmationPage from "./pages/OrderConfirmationPage";
import CalendarPage from "./pages/CalendarPage";
import ContactPage from "./pages/ContactPage";
import FlappyBirdPage from "./pages/FlappyBirdPage";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="register" element={<RegisterPage />} />
          <Route path="menu/:restaurant" element={<MenuPageV2 />} />
          {/* <Route path="menu-old" element={<MenuPage />} /> */}
          <Route path="cart" element={<CartPage />} />
          <Route path="success" element={<SuccessPage />} />
          <Route
            path="order-confirmation/:id"
            element={<OrderConfirmationPage />}
          />
          <Route path="order-history" element={<OrderHistoryPage />} />

          {/* Legacy checkout page replaced with stripe checkout page */}
          {/* <Route
            path="checkout"
            element={
              <ProtectedRoute>
                <CheckoutPage />
              </ProtectedRoute>
            }
          /> */}

          <Route
            path="orders"
            element={
              <ProtectedRoute>
                <OrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="orders/:id"
            element={
              <ProtectedRoute>
                <OrderDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="restaurant"
            element={
              <ProtectedRoute requiredRole="staff">
                <RestaurantDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="analytics"
            element={
              <ProtectedRoute>
                <AnalyticsPage />
              </ProtectedRoute>
            }
          />
          <Route path="calendar" element={<CalendarPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="game" element={<FlappyBirdPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
